module.exports = __webpack_public_path__ + "assets/2031b94a852b4634e93cfb086270625e.png";